import { UserPreferences } from 'core/schema/queries';
import { aomGraphqlRequest } from 'core/utils/backend-service';
import { getUserLanguageQuery, saveUserLanguageMutation } from './user-language.queries';

export const getUserLanguage = async (): Promise<string> =>
    aomGraphqlRequest(getUserLanguageQuery()).then(
        (result) => (result.data.userPreferences as UserPreferences).language.languageName
    );

export const saveUserLanguage = async (userPreferencesId: string, language: string): Promise<{ result: string }> =>
    aomGraphqlRequest(saveUserLanguageMutation(), { language: { userPreferencesId, languageName: language } }).then(
        () => ({ result: 'ok' })
    );
